import React from 'react';
import NumberFormat from 'react-number-format';

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref,
) {
  const { onChange, isNegative, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="₩"
      allowNegative={isNegative ? 'true' : 'false'}
      decimalScale={0} //소수점 허용안함.
    />
  );
});

export default NumberFormatCustom;
